export default () => {
  const { $gtm, $posthog } = useNuxtApp()

  const trackSubmitContactForm = () => {
    $gtm.push({
      event: 'submittedContactForm',
    })

    $posthog.capture('contact_form_submitted')
  }

  const trackCancelSubscription = () => {
    $posthog.capture('subscription_cancellation_sent')
  }

  return {
    trackSubmitContactForm,
    trackCancelSubscription,
  }
}
